import { render, staticRenderFns } from "./ExchangeRecords.vue?vue&type=template&id=30f6d546&scoped=true&"
import script from "./ExchangeRecords.vue?vue&type=script&lang=js&"
export * from "./ExchangeRecords.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRecords.vue?vue&type=style&index=0&id=30f6d546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6d546",
  null
  
)

export default component.exports